function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9 5H5v6h4V5zm10 8h-4v6h4v-6zM5 17h4v2H5v-2zM19 5h-4v2h4V5z",
  opacity: ".3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 13H3V3h8v10zM9 5H5v6h4V5zm4 16h8V11h-8v10zm6-8h-4v6h4v-6zM13 3v6h8V3h-8zm2 4h4V5h-4v2zM3 21h8v-6H3v6zm6-4H5v2h4v-2z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}));